import React, { useState, useEffect } from 'react';

import { useNavigate, Link, useParams } from 'react-router-dom';
import db from "./Firebase";
import { arrayUnion } from "firebase/firestore";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import ViewAllRequests from './ViewAllRequests';
import { CSVLink } from "react-csv";

function Workshop() {
    const navigate = useNavigate();
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [wdata, setWdata] = useState([]);
    const [csvdata, setCsvdata] = useState([]);

    const [mappedData, setMappedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [certData, setCertData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [wdataLoaded, setWdataLoaded] = useState(false);
    const [certLoaded, setCertLoaded] = useState(false);
    const loading = !dataLoaded || !wdataLoaded || !certLoaded;

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }
    }, []);

    const headers = [
        { label: "Workshop Name", key: "name" },
        { label: "Expert", key: "expert" },
        { label: "Tag", key: "tag" },
        { label: "Start Date Time", key: "start_date_time" },
        { label: "End Date Time", key: "end_date_time" },
        { label: "Total Registrations", key: "totalRegistrations" },
        { label: "Cert Downloads", key: "certDownloads" },
    ];

    useEffect(() => {
        // db.collection("workshop_event_data_hindi").orderBy("created_date", "desc").onSnapshot((snapshot) => {

        //     setData(
        //         snapshot.docs.map((doc) => ({
        //             id: doc.id,
        //             data: doc.data(),
        //         }))
        //     );

        //     setCsvdata(
        //         snapshot.docs.map((doc) => {
        //             const data = doc.data();
        //             return {
        //                 ...data,
        //                 start_date_time: moment(data.start_date_time.toDate().toISOString()).format("MM/DD/YY, h:mm a"),
        //                 end_date_time: moment(data.end_date_time.toDate().toISOString()).format("MM/DD/YY, h:mm a"),
        //             };
        //         })
        //     );
        // });

        db.collection("workshop_event_data").orderBy("created_date", "desc").onSnapshot((snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
            setDataLoaded(true);
        });

        // db.collection("workshop_registration").orderBy("created_date", "desc").onSnapshot((snapshot) => {
        //     setWdata(
        //         snapshot.docs.map((doc) => ({
        //             id: doc.id,
        //             data: doc.data(),
        //         }))
        //     );
        // });
        db.collection("workshop_registration").orderBy("created_date", "desc").onSnapshot((snapshot) => {
            setWdata(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
            setWdataLoaded(true);
        });

        db.collection("nv_certificates_download").onSnapshot((snapshot) => {
            setCertData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
            setCertLoaded(true);
        });

    }, []);


    useEffect(() => {
        const seenCerts = new Set();
        const certCountMap = new Map();
        certData.forEach(({ data }) => {
            const workshop = data['certificate_for'];
            const phone = data['phone_no'];
            if (!workshop || !phone) return;
            const uniqueKey = `${workshop}__${phone}`;
            if (seenCerts.has(uniqueKey)) return;
            seenCerts.add(uniqueKey);
            certCountMap.set(workshop, (certCountMap.get(workshop) || 0) + 1);
        });

        const mapped = mapWorkshopsToRegistrations(data, wdata).map((row) => ({
            ...row,
            certDownloads: certCountMap.get(row.name) || 0,
        }));

        setMappedData(mapped);
        setCsvdata(mapped.map((row) => ({
            ...row,
            start_date_time: row.start_date_time ? moment(row.start_date_time.toDate().toISOString()).format("MM/DD/YY, h:mm a") : '',
            end_date_time: row.end_date_time ? moment(row.end_date_time.toDate().toISOString()).format("MM/DD/YY, h:mm a") : '',
        })));
    }, [data, wdata, certData]);



    // const [idNameMapping, setIdNameMapping] = useState([]);
    // const idmapping = () => {
    //     {
    //         wdata.map(({ id, data }, index) => (
    //             idNameMapping[data.workshop_event_name] = (idNameMapping[data.workshop_event_name] || 0) + 1
    //         ))
    //         console.log(idNameMapping[data.workshop_event_name]);
    //     }
    // }

    async function deleteDuplicateCertificates() {
        console.log("=== Starting duplicate certificate cleanup ===");
        console.log(`Total cert records fetched: ${certData.length}`);

        const seenKeys = new Map();

        certData.forEach(({ id, data }) => {
            const workshop = data['certificate_for'];
            const phone = data['phone_no'];
            if (!workshop || !phone) {
                console.warn(`Skipping doc ${id} — missing certificate_for or phone_no`);
                return;
            }
            const uniqueKey = `${workshop}__${phone}`;
            if (!seenKeys.has(uniqueKey)) {
                seenKeys.set(uniqueKey, id);
            }
        });

        const keepIds = new Set(seenKeys.values());
        const toDelete = certData.filter(({ id }) => !keepIds.has(id));

        console.log(`Unique entries to keep: ${keepIds.size}`);
        console.log(`Duplicate entries to delete: ${toDelete.length}`);

        if (toDelete.length === 0) {
            console.log("No duplicates found. Nothing to delete.");
            return;
        }

        let deleted = 0;
        for (const { id, data } of toDelete) {
            console.log(`Deleting doc ${id} — certificate_for: "${data['certificate_for']}", phone_no: "${data['phone_no']}"`);
            await db.collection("nv_certificates_download").doc(id).delete();
            deleted++;
        }

        console.log(`=== Cleanup complete. Deleted ${deleted} duplicate(s). ===`);
    }

    function mapWorkshopsToRegistrations(workshops, registrations) {
        const workshopMap = new Map();

        // Create a map of workshop names to workshop data
        workshops.forEach(({ id, data }) => {
            workshopMap.set(data['name'], { id, name: data['name'], expert: data['expert'], tag: data['tag'] || '', end_date_time: data['end_date_time'], start_date_time: data['start_date_time'], totalRegistrations: 0 });
        });

        // Count registrations for each workshop
        registrations.forEach(({ id, data }) => {
            const workshopName = data['workshop_event_name'];
            if (workshopMap.has(workshopName)) {
                workshopMap.get(workshopName).totalRegistrations++;
            }
        });

        // Convert the map values to an array
        const mappedData = Array.from(workshopMap.values());

        return mappedData;
    }


    return (
        <>
            <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
                <div class="p-2" style={{ textAlign: "start", paddingBottom: "5px", width: "8rem" }}>
                    {/* <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span> */}
                    <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

                </div>
                <div class="">
                    <div class="p-2">
                        <div style={{ textAlign: "end", paddingBottom: "5px" }}>
                            {/* <Link to="/admin_panel" class="btn bg-gradient-primary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Go Back</Link> */}
                            <Link to="/workshop_hindi_reg" class="btn bg-gradient-primary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Workshop Hindi Registration Data</Link>

                            <CSVLink data={csvdata} headers={headers} filename="workshop_data.csv">
                                <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span>
                            </CSVLink>
                            {/* <span
                                class="btn bg-gradient-danger btn-sm mb-0 mr-2"
                                style={{ color: "white", cursor: "pointer" }}
                                onClick={() => {
                                    if (window.confirm(`This will delete duplicate certificate entries (keeping 1 per phone+workshop). Check console for logs. Proceed?`)) {
                                        deleteDuplicateCertificates();
                                    }
                                }}
                            >&nbsp; Delete Duplicate Certs</span> */}
                        </div>
                        <div class="card">
                            <div class="card-header pb-0 px-3">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">All Workshop Registration</h6>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        placeholder="Search by workshop name..."
                                        style={{ maxWidth: "280px" }}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="">
                                <div class="card">
                                    <div class="table-responsive fix-width scroll-inner">
                                        <table class="table table-bordered table-hover">
                                            <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                                                <tr style={{ textAlign: "left" }}>
                                                    <th class="col ps-2">#</th>
                                                    <th class="col ps-2">Workshop Name</th>
                                                    <th class="col">Expert</th>
                                                    <th class="col ps-2">Tag</th>
                                                    <th class="col ps-2">Start Date Time</th>
                                                    <th class="col ps-2">End Date Time</th>
                                                    <th class="col ps-2">Total Registration</th>
                                                    <th class="col ps-2">Cert Downloads</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "left" }}>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan="8" style={{ textAlign: "center", padding: "2rem" }}>
                                                            <div className="spinner-border text-primary" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                            <p className="text-xs mt-2 mb-0" style={{ color: "#7b809a" }}>Loading workshop data...</p>
                                                        </td>
                                                    </tr>
                                                ) : mappedData
                                                    .filter(({ name }) => name?.toLowerCase().includes(searchQuery.toLowerCase()))
                                                    .map(({ id, name, expert, tag, end_date_time, start_date_time, totalRegistrations, certDownloads }, index) => (
                                                        <tr key={id}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <p className="text-xs font-weight-bold mb-0">{name}</p>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex px-2 py-1">
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <h6 className="mb-0 text-xs">{expert}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex px-2 py-1">
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <h6 className="mb-0 text-xs">{tag}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex px-2 py-1">
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <h6 class="mb-0 text-xs">{moment(start_date_time.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex px-2 py-1">
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <h6 className="mb-0 text-xs">{moment(end_date_time.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex px-2 py-1">
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <h6 className="mb-0 text-xs">{totalRegistrations}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex px-2 py-1">
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <h6 className="mb-0 text-xs">{certDownloads}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </main>


        </>
    )
}

export default Workshop;